import { ModalUpdateCollectionMemoStoreInterface } from '@/store/ModalUpdateCollectionMemoStore'
import { modalUpdateCollectionMemoStore } from '@/utils/store-accessor'

export class ModalUpdateCollectionMemoService {
  public open(params: ModalUpdateCollectionMemoStoreInterface) {
    modalUpdateCollectionMemoStore.open(params)
  }

  public close() {
    modalUpdateCollectionMemoStore.close()
  }
}
